import { ActionType } from '../action_types';
import { LoanRepayment } from "../../interfaces/loan"
import { FetchLoanRepaymentsAction } from "../actions/loan.actions"

interface LoanRepaymentState {
  loanRepayments: LoanRepayment[]
}

const initialState: LoanRepaymentState = {
  loanRepayments: []
}

const loanRepaymentReducer = (state = initialState, action: FetchLoanRepaymentsAction): LoanRepaymentState => {
  switch (action.type) {
    case ActionType.FETCH_LOAN_REPAYMENTS:
      return { loanRepayments: action.payload.loanRepayment }

    default:
      return {...state}
  }
}

export default loanRepaymentReducer;
